import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../lib/auth";
import storage from "../../../utils/storage";
import { SmoothCorners } from "react-smooth-corners";

const ProductCard = ({ categoryId, product, onQuantityChange }: any) => {
  const { user, incrementOrderCount } = useAuth();
  const [buttonState, setButtonState] = useState<"add" | "added" | "remove">(
    "add"
  );
  const navigate = useNavigate();

  useEffect(() => {
    const storageData = storage.getCard();
    if (storageData && Array.isArray(storageData)) {
      const storedProduct = storageData.find(
        (item: any) => item.productId === product.id
      );
      setButtonState(
        storedProduct && storedProduct.quantity > 0 ? "remove" : "add"
      );
    }
  }, [product.id]);

  const handleButtonClick = (e: any) => {
    e.stopPropagation();
    if (!user) {
      onQuantityChange();
      return;
    }

    if (buttonState === "add") {
      storage.setCard(product.id, 1);
      incrementOrderCount(true);
      setButtonState("added");
      setTimeout(() => setButtonState("remove"), 3000);
    } else if (buttonState === "remove") {
      storage.setCard(product.id, 0);
      incrementOrderCount(false);
      setButtonState("add");
    }
  };

  return (
    <SmoothCorners
      corners="12 8 20 10"
      style={{ width: "100%", height: "100%" }}
    >
      <div
        className="bg-white shadow-md p-2 flex flex-col space-y-3 hover:shadow-lg transition-shadow"
        onClick={() => navigate(`/home/${categoryId}/${product.id}`)}
        style={{ borderRadius: "inherit" }}
      >
        {/* Product Image */}
        <div className="relative w-full aspect-square bg-gray-50 overflow-hidden">
          <img
            src={product.images?.[0]?.image_path || "لا توجد صورة"}
            alt={product.name_ar}
            className="w-full h-full object-contain p-2"
          />
        </div>

        {/* Product Details */}
        <div className="flex flex-col items-end justify-end text-center">
          <h3 className="text-lg font-semibold text-gray-900">
            {product.name_ar}
          </h3>
        </div>

        {/* Price */}
        <div className="flex items-center justify-center text-lg font-bold text-gray-800">
          {product.price} الف
        </div>

        {/* Action Button */}
        <button
          onClick={handleButtonClick}
          className="w-full py-2 px-4 rounded-lg font-semibold transition-colors text-white bg-red-600 hover:bg-red-700"
        >
          {buttonState === "add"
            ? "إضافة إلى السلة"
            : buttonState === "added"
            ? "تمت الإضافة"
            : "حذف من السلة"}
        </button>
      </div>
    </SmoothCorners>
  );
};

export default ProductCard;
